import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import PropTypes from "prop-types";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { Radio, TextField } from "@material-ui/core";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { BreadcrumbPage } from "../../shared";
import { CommonCss } from "../../services/CommonCss";
import clsx from "clsx";
import { Grid } from "@material-ui/core";
import { getRequest, postRequest, putRequest } from "../../services/ApiServices";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import { todayDate } from "../../services/DateServices";
import userObj from "./UserInstantiation";
import { LOADING } from '../../action'
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useSelector, useDispatch } from 'react-redux';
import { List } from 'react-virtualized';
import EllipsisText from "react-ellipsis-text";
import { getCookie } from "../../services/Cookies";
import Help from "@material-ui/icons/Help";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { HelpChart } from "./HelpChart";

const useStyles = makeStyles((theme) => ({
  boxLayout: {
    backgroundColor: "#fff",
    boxShadow: "0px 0px 2px 1px rgb(0 0 0 / 12%)",
    borderRadius: 8,
  },
  txtInput: {
    "& input": {
      padding: "8px 8px",
      fontWeight: 600,
    },
    "& fieldset": {
      borderRadius: 0,
    },
  },
  breadcrumbBox: {
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
  },
  btnStyle1: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ff4717",
    background: "#fff !important",
    textTransform: "capitalize",
    padding: "4px 22px",
  },
  btnStyle2: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
    marginRight: "8px"
  },
  radioInput: {
    padding: 0,
    "& span.Mui-checked": {
      color: "#1a1a31",
    },
  },
  mainSelectDropdown: {
    border: "1px solid #000",
    padding: "8px 10px 8px !important",
    float: "left",
  },
  selectDropdown: {
    height: "100px",
    overflowY: "auto",
  },
  iconSelect: {
    position: "absolute",
    right: "-8px",
  },
  dropdownActive: {
    display: "block",
  },
  dropdownInactive: {
    display: "none",
  },
  formControl: {
    width: "100%",
  },
  selectDropdownActive: {
    color: "#ff4717",
  },
  seletedItem: {
    padding: "4px 8px",
    backgroundColor: "#ff47174a",
    marginRight: "4px",
    borderRadius: "16px",
    float: "left",
    marginBottom: "4px",
    fontSize: "11px",
  },
  autoTextbox: {
    border: "0px"
  },
  searchTxt: {
    "& .MuiFormControl-root": {
      margin: "0px !important",
      borderTop: "1px solid #000 !important",
      borderLeft: "1px solid #000 !important",
      borderRight: "1px solid #000 !important"
    },
    "& .MuiInputBase-root": {
      outline: "0px solid #000 !important",
      margin: "0px !important"
    },
    "& .MuiInputBase-root fieldset": {
      border: "0px solid #000 !important"
    }
  },
  readonlyTxt: {
    "& input": {
      backgroundColor: "#eee",
      padding: "8px 8px"
    }
  },
  dialogbox:{
     "& .MuiDialog-container .MuiDialog-paperWidthSm" :{
      display:"flex",
      maxWidth: "fit-content"
     }
  }

}));


export default function AddUser(props) {
  // //console.log(props);
  // //console.log(props.match.params.email);
  const classes = useStyles();
  const history = useHistory();
  const classesCommonCss = CommonCss();
  const [BreadcrumbList, setBreadcrumbList] = useState(
    [
      { name: "Admin Panel", url: "/dashboard/admin" },
      { name: "Add New User", url: "" },
    ]);
  const [formObj, setFormObj] = useState(userObj);
  const [Formvalue, setFormvalue] = useState({ customername: "" });
  const [Formvaluecustomer, setFormvaluecustomer] = useState({ customername: "" });
  const [Formvalue1, setFormvalue1] = useState({ contract: "" });
  const [SelectedContractDropdown, setSelectContractDropdown] = useState();
  const [value, setValue] = useState('');
  const [valueCustomer, setValueCustomer] = useState('')

  const [formAction, setFormAction] = useState("add");

  const [userTypeDetails, setUserTypeDetails] = React.useState([]);

  const [customerDetails, setCustomerDetails] = React.useState([]);
  const [customerDropdown, setCustomerDropdown] = React.useState("open");

  const [contractDetails, setContractDetails] = React.useState([]);
  const [contractDropdown, setContractDropdown] = React.useState("open");

  const [assettypeDetails, setAssettypeDetails] = React.useState([]);
  const [assettypeDropdown, setAssettypeDropdown] = React.useState("open");

  const [locationDetails, setLocationDetails] = React.useState([]);
  const [locationDropdown, setLocationDropdown] = React.useState("open");

  const [assetDetails, setAssetDetails] = React.useState([]);
  const [assetDropdown, setAssetDropdown] = React.useState("open");

  const [serviceDetails, setServiceDetails] = React.useState([]);
  const [serviceDropdown, setServiceDropdown] = React.useState("open");

  const [equipmentDetails, setEquipmentDetails] = React.useState([]);
  const [equipmentDropdown, setEquipmentDropdown] = React.useState("open");
  const [customerDetailsBySearch, setCustomerDetailsBySearch] = React.useState([]);
  const [fullWidth, setFullWidth] = React.useState(true);
  const [scroll, setScroll] = React.useState('paper');
  // const list = locationDetails ;
  const [openform, setOpenform] = React.useState(false);
  const handleClickOpenForm = () => {
    setOpenform(true);
  };
  const handleClickClose = () => {
    setOpenform(false);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    fetchData();
  }, []);
  // const autoTextCustomer = (event) =>{
  //   //console.log(event.target.value);
  // }

  const autoTextCustomer = (event) => {
    //
    let searchStr = event.target.value;
    // setValue(searchStr);
    setValueCustomer(searchStr);
    //console.log(searchStr,"SEARCH");
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Customer/${searchStr}`;
    getRequest(url)
      .then((res) => {
        // //console.log(res);
        if (res.status == 200) {
          let totalArray = [];
          res.data.map((item) => {
            if (item.customerName || item.customerkeys) {
              totalArray.push(item);
            }
          });
          setCustomerDetailsBySearch(totalArray);
        } else {
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        //console.log(error);
        // ToastError(error.response.data.message);
      });
  }
  // //console.log(customerDetailsBySearch);
  const fetchData = async () => {
    dispatch({ type: LOADING, payload: true });
    await getAssettypes();
    await getUserTypes();
    await getUserByEmail(props.match.params.email);
    // await getCustomers();
    dispatch({ type: LOADING, payload: false });
  }
  const onChangeSearchText = (data, type) => {
    // //console.log(data, type,'dropdownsearch')
    if (type == "searchLocation") {
      if (data) {
        getLocationSearch(formObj.customerKeys, formObj.contractKeys, formObj.assetTypes, data);
      } else {
        getLocation(formObj.customerKeys, formObj.contractKeys, formObj.assetTypes);
      }
    } else if (type == "searchAssets") {
      if (data) {
        getAssetsSearch(formObj.customerKeys, formObj.contractKeys, formObj.assetTypes, data);
      } else {
        getAssets(formObj.customerKeys, formObj.contractKeys, formObj.assetTypes, formObj.location);
      }
    } else if (type == "searchServices") {
      if (data) {
        getServicesSearch(formObj.customerKeys, formObj.contractKeys, data);
      } else {
        getServices(formObj.customerKeys, formObj.contractKeys, formObj.location);
      }
    } else if (type == "searchEquipment") {
      if (data) {
        getEquipmentSearch(formObj.customerKeys, formObj.contractKeys, formObj.assetTypes, formObj.assets, data);
      } else {
        getEquipments(formObj.customerKeys, formObj.contractKeys, formObj.assetTypes, formObj.assets);
      }
    }
  }

  const getLocationSearch = async (customerkeys, contractKeys, assettypes, searchData) => {
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Location/Search`;
    const data = {
      customerKeys: customerkeys.toString(),
      contractKeys: contractKeys.toString(),
      assettypes: assettypes.toString(),
      locationName: searchData
    }
    await postRequest(url, data)
      .then((res) => {
        // //console.log(res);
        if (res.status == 200) {
          let obj = { location: "All" };
          let result = res.data;
          result.unshift(obj);
          setLocationDetails(result);
          // onSeletDropdown('location',res.data);
        } else {
          ToastError(res.message);
        }
      })
      .catch((error) => {
        //console.log(error);
        // ToastError(error.response.data.message);
      });
  }

  const getAssetsSearch = async (customerkeys, contractKeys, assettypes, searchData) => {
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `PickList/assets/Search/${customerkeys.toString()}/${contractKeys.toString()}/${assettypes.toString()}/${searchData.toString()}`;
    await getRequest(url)
      .then((res) => {
        // //console.log(res);
        if (res.status == 200) {
          // let obj =  ["All"];
          let obj = [-1];
          res.data.map((item) => {
            if (item.name) {
              obj.push(item);
            }
          });
          setAssetDetails(obj);
        } else {
          ToastError(res.message);
        }
      })
      .catch((error) => {
        //console.log(error);
        // ToastError(error.response.data.message);
      });
  }

  const getServicesSearch = async (customerkeys, contractKeys, dataSearch) => {
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `PickList/services/Search/${customerkeys}/${contractKeys}/${dataSearch}`;
    await getRequest(url)
      .then((res) => {
        // //console.log(res);
        if (res.status == 200) {
          let obj = { "product": "All" };
          let result = res.data;
          result.unshift(obj);
          setServiceDetails(result);
        } else {
          ToastError(res.message);
        }
      })
      .catch((error) => {
        //console.log(error);
        // ToastError(error.response.data.message);
      });
  }

  const getEquipmentSearch = async (customerkeys, contractKeys, assettypes, vesselKeys, dataSearch) => {
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Ship/AdminEquipmentsSearch`;
    const data = {
      customerKeys: customerkeys.toString(),
      contractKeys: contractKeys.toString(),
      vesselKeys: vesselKeys.toString(),
      assettypes: assettypes.toString(),
      vesselName: dataSearch
    }
    // const data = {
    //   "customerKeys": "32884913",
    //   "contractKeys": "5151687",
    //   "vesselKeys": "ENGIADINA",
    //   "assettypes": "Vessels"
    // }
    await postRequest(url, data)
      .then((res) => {
        // //console.log(res);
        if (res.status == 200) {
          let obj = { "machineryUsageType": "All" };
          let result = res.data;
          result.unshift(obj);
          setEquipmentDetails(result);
        } else {
          ToastError(res.message);
        }
      })
      .catch((error) => {
        //console.log(error);
        // ToastError(error.response.data.message);
      });
  }


  const onMultiSelect = (type, arrName, obj, keyVal) => {
    //
    //console.log(type, arrName,  obj, keyVal);
    let selectedIndex = arrName.indexOf(keyVal);
    if (type == "assets") {
      selectedIndex = formObj.assets.findIndex(i => i.key == keyVal.key);
    }
    // //console.log(selectedIndex);
    let newSelected = [];

    if (keyVal === -1 && selectedIndex === -1) {
      arrName = [];
      newSelected = newSelected.concat(arrName, keyVal);
    } else if (keyVal === 'All' && selectedIndex === -1) {
      arrName = [];
      newSelected = newSelected.concat(arrName, keyVal);
    } else if (selectedIndex === -1) {

      let indexAll = -1;
      if (type == "contract") {
        indexAll = arrName.indexOf(-1);
      } else {
        indexAll = arrName.indexOf('All');
      }
      if (indexAll === 0) {
        arrName = arrName.slice(1);
      } else if (indexAll === arrName.length - 1) {
        arrName = arrName.slice(0, -1)
      } else if (indexAll > 0) {
        arrName.concat(arrName.slice(0, indexAll),
          arrName.slice(indexAll + 1))
      }

      newSelected = newSelected.concat(arrName, keyVal);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(arrName.slice(1));
    } else if (selectedIndex === arrName.length - 1) {
      newSelected = newSelected.concat(arrName.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        arrName.slice(0, selectedIndex),
        arrName.slice(selectedIndex + 1)
      );
    }
    let stringVal = ['All'];
    let numberVal = [-1];
    if (type == "customer") {
      if (newSelected.length == 0) { newSelected = [] }
    } else if (type == "contract") {
      if (newSelected.length == 0) { newSelected = numberVal }
    } else {
      if (newSelected.length == 0) { newSelected = stringVal }
    }
    if (type == "customer") {
      //console.log(newSelected,'Customer..')
      // setValue('');
      setValueCustomer('');
      setCustomerDetailsBySearch([]);
      setFormObj({ ...formObj, ["customerKeys"]: newSelected, ["contractKeys"]: numberVal, ["location"]: stringVal, ["assets"]: numberVal, ["service"]: stringVal, ["equipment"]: stringVal });

      selectCustomerDropdown(newSelected, stringVal);
      // setContractDetails([]);
      // setLocationDetails([]);
      // setAssetDetails([]);
      // setServiceDetails([]);      
      // setEquipmentDetails([]);
      // getContracts(newSelected);
      // getLocation(formObj.customerKeys,newSelected, formObj.assetTypes); 
      // getAssets(formObj.customerKeys,newSelected, formObj.assetTypes, stringVal);
      // getServices(formObj.customerKeys,newSelected, stringVal);  
      // getEquipments(formObj.customerKeys,newSelected, stringVal,stringVal); 
    } else if (type == "contract") {
      setFormObj({ ...formObj, ["contractKeys"]: newSelected, ["location"]: stringVal, ["assets"]: stringVal, ["service"]: stringVal, ["equipment"]: stringVal });
      selectContractDropdown(newSelected, stringVal);
      setSelectContractDropdown(newSelected);
      //getContracts(newSelected)
      // setLocationDetails([]);
      // setAssetDetails([]);
      // setServiceDetails([]);      
      // setEquipmentDetails([]);
      // getLocation(formObj.customerKeys,newSelected, formObj.assetTypes); 
      // getAssets(formObj.customerKeys,newSelected, formObj.assetTypes, stringVal);
      // getServices(formObj.customerKeys,newSelected, stringVal);  
      // getEquipments(formObj.customerKeys,newSelected, stringVal,stringVal);
    } else
      if (type == "assettype") {
        setFormObj({ ...formObj, ["assetTypes"]: newSelected, ["location"]: stringVal, ["assets"]: stringVal, ["equipment"]: stringVal });
        selectAssetTypeDropdown(newSelected, stringVal);
        // setLocationDetails([]);
        // setAssetDetails([]);
        // setEquipmentDetails([]);
        // getLocation(formObj.customerKeys,formObj.contractKeys, newSelected); 
        // getAssets(formObj.customerKeys,formObj.contractKeys, newSelected, stringVal);
        // getEquipments(formObj.customerKeys,formObj.contractKeys, newSelected, stringVal);
      } else
        if (type == "location") {
          newSelected = newSelected.map(function (e) { return e.toString() });
          //console.log(newSelected);
          setFormObj({ ...formObj, ["location"]: newSelected, ["assets"]: stringVal, ["service"]: stringVal });
          selectLocationDropdown(newSelected, stringVal);
          // setAssetDetails([]);
          // setServiceDetails([]);
          // getAssets(formObj.customerKeys,formObj.contractKeys, formObj.assetTypes, newSelected); 
          // getServices(formObj.customerKeys,formObj.contractKeys, newSelected); 
        } else
          if (type == "assets") {
            setFormObj({ ...formObj, ["assets"]: newSelected, ["assetsName"]: newSelected, ["equipment"]: stringVal });
            const assetName = newSelected.map((obj) => { return obj.key; });
            //console.log(assetName);
            selectAssetsDropdown(assetName, numberVal);
            // setEquipmentDetails([]);
            // getEquipments(formObj.customerKeys,formObj.contractKeys, formObj.assetTypes, obj);
          } else
            if (type == "services") {
              setFormObj({ ...formObj, ["service"]: newSelected });
            } else
              if (type == "equipment") {
                setFormObj({ ...formObj, ["equipment"]: newSelected });
              }

  };
  const selectCustomerDropdown = (newSelected, stringVal) => {
    setContractDetails([]);
    setLocationDetails([]);
    setAssetDetails([]);
    setServiceDetails([]);
    setEquipmentDetails([]);
    if (newSelected) {
      getContracts(newSelected);
      let numberVal = [-1];
      getLocation(newSelected, numberVal, formObj.assetTypes);
      getAssets(newSelected, numberVal, formObj.assetTypes, stringVal);
      getServices(newSelected, numberVal, stringVal);
      getEquipments(newSelected, numberVal, stringVal, stringVal);
    }
  }
  const selectContractDropdown = (newSelected, stringVal) => {
    setLocationDetails([]);
    setAssetDetails([]);
    setServiceDetails([]);
    setEquipmentDetails([]);
    //getContracts(newSelected)
    getLocation(formObj.customerKeys, newSelected, formObj.assetTypes);
    getAssets(formObj.customerKeys, newSelected, formObj.assetTypes, stringVal);
    getServices(formObj.customerKeys, newSelected, stringVal);
    getEquipments(formObj.customerKeys, newSelected, stringVal, stringVal);
  }
  const selectAssetTypeDropdown = (newSelected, stringVal) => {
    setLocationDetails([]);
    setAssetDetails([]);
    setServiceDetails([]);
    setEquipmentDetails([]);
    if (formObj.customerKeys.length) {
      getLocation(formObj.customerKeys, formObj.contractKeys, newSelected);
      getAssets(formObj.customerKeys, formObj.contractKeys, newSelected, stringVal);
      getServices(formObj.customerKeys, formObj.contractKeys, stringVal);
      getEquipments(formObj.customerKeys, formObj.contractKeys, newSelected, stringVal);
    }
  }
  const selectLocationDropdown = (newSelected, stringVal) => {
    setAssetDetails([]);
    setServiceDetails([]);
    setEquipmentDetails([]);
    getAssets(formObj.customerKeys, formObj.contractKeys, formObj.assetTypes, newSelected);
    getServices(formObj.customerKeys, formObj.contractKeys, newSelected);
    getEquipments(formObj.customerKeys, formObj.contractKeys, formObj.assetTypes, stringVal);
  }
  const selectAssetsDropdown = (newSelected, stringVal) => {
    setEquipmentDetails([]);
    getEquipments(formObj.customerKeys, formObj.contractKeys, formObj.assetTypes, newSelected);
  }
  const onClearDropdown = (type) => {
    let stringVal = ['All'];
    let numberVal = [-1];
    if (type == "contract") {
      setFormObj({ ...formObj, ["contractKeys"]: numberVal, ["location"]: stringVal, ["assets"]: numberVal, ["service"]: stringVal, ["equipment"]: stringVal });
      selectContractDropdown(numberVal, stringVal);
    } else if (type == "assettype") {
      setFormObj({ ...formObj, ["assetTypes"]: stringVal, ["location"]: stringVal, ["assets"]: numberVal, ["service"]: stringVal, ["equipment"]: stringVal });
      selectAssetTypeDropdown(stringVal, stringVal);
    } else if (type == "location") {
      setFormObj({ ...formObj, ["location"]: stringVal, ["assets"]: numberVal, ["service"]: stringVal });
      selectLocationDropdown(stringVal, stringVal);
    } else if (type == "assets") {
      setFormObj({ ...formObj, ["assets"]: numberVal, ["equipment"]: stringVal });
      selectAssetsDropdown(stringVal, stringVal);
    } else if (type == "services") {
      setFormObj({ ...formObj, ["service"]: stringVal });
    } else if (type == "equipment") {
      setFormObj({ ...formObj, ["equipment"]: stringVal });
    }

  }
  const onSeletDropdown = (type, data) => {
    //console.log(type, data);
    let stringVal = ['All'];
    let numberVal = [-1];
    if (type == "contract") {
      setFormObj({ ...formObj, ["contractKeys"]: numberVal, ["location"]: stringVal, ["assets"]: stringVal, ["service"]: stringVal, ["equipment"]: stringVal });
      selectContractDropdown(numberVal, stringVal);
    } else if (type == "assettype") {
      setFormObj({ ...formObj, ["assetTypes"]: stringVal, ["location"]: stringVal, ["assets"]: stringVal, ["service"]: stringVal, ["equipment"]: stringVal });
      selectAssetTypeDropdown(stringVal, stringVal);
    } else if (type == "location") {
      setFormObj({ ...formObj, ["location"]: stringVal, ["assets"]: stringVal, ["service"]: stringVal });
      selectLocationDropdown(stringVal, stringVal);
    } else if (type == "assets") {
      setFormObj({ ...formObj, ["assets"]: stringVal, ["equipment"]: stringVal });
      selectAssetsDropdown(stringVal, stringVal);
    } else if (type == "services") {
      setFormObj({ ...formObj, ["service"]: stringVal });
    } else if (type == "equipment") {
      setFormObj({ ...formObj, ["equipment"]: stringVal });
    }
  }
  const addUserSubmit = (event) => {
    //
    let formObjData = { ...formObj, status: (getCookie("userRole") == "VPS Admin") ? "Registered" : formObj.status, assets: formObj.assets[0] == 'All' ? [{ name: 'All', key: -1 }] : formObj.assets };
    let contractFilter = contractDetails.filter((item) => {
      if (formObj.contractKeys.includes(item.contractKey)) {
        return item.axContractId
      }
    })
    let selectedContract = contractFilter.map((f) => f.axContractId)
    let contract = selectedContract.join();
    //console.log(contract);
    let Asset = formObj.assets.map((obj) => {
      return obj.key
    })
    let x = assetDetails.filter((item) => {
      if (Asset.includes(item.key)) {
        return item.name
      }
    })

    let selectedAssets = x.map((f) => f.name)
    let Assets = selectedAssets.join();
    //console.log(Assets);

    let changes = `AddUserSubmit/firstname:${formObjData.firstName},
    lastname:${formObjData.lastName},
    role:${formObjData.role},
    service:${formObjData.service.join(',')},
    assectType:${formObjData.assetTypes.join(',')},
    assets:${Assets == "" ? "All" : Assets},
    usertype:${formObjData.userType.replaceAll(' ', '_')},
    status:${formObjData.isActive},
    location:${formObjData.location.join(',')},
    equipment:${formObjData.equipment.join(',')},
    contract:${contract},
    customername:${Formvalue.customername}`;

    formObjData.changes = changes;
    dispatch({ type: LOADING, payload: true });
    event.preventDefault();
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `User`;
    dispatch({ type: LOADING, payload: true });
    postRequest(url, formObjData)
      .then((res) => {
        if (res.status == 200) {
          dispatch({ type: LOADING, payload: false });
          ToastSuccess("Inserted successfully");
          //history.push("/dashboard/admin");

        } else {
          ToastError(res.data.message);
          dispatch({ type: LOADING, payload: false });
        }
      })
      .catch((error) => {
        //console.log(error);
        dispatch({ type: LOADING, payload: false });
        ToastError(error.response.data.message);
      });
    // }

  };
  //;
  const updateUserSubmit = (event) => {
    //
    // if(formObj.customerKeys.length == 0){
    //   event.preventDefault();
    //   ToastError("Please select customer key");
    // } else {
    ;
    let formObjData = { ...formObj, assets: formObj.assets[0] == 'All' || formObj.assets[0] === -1 ? [{ name: 'All', key: -1 }] : formObj.assets };
    let contractFilter = contractDetails.filter((item) => {
      if (formObj.contractKeys.includes(item.contractKey)) {
        return item.axContractId
      }
    })
    let selectedContract = contractFilter.map((f) => f.axContractId)
    let contract = selectedContract.join();
    //console.log(contract);
    let Asset = formObj.assets.map((obj) => {
      return obj.key
    })
    let x = assetDetails.filter((item) => {
      if (Asset.includes(item.key)) {
        return item.name
      }
    })


    let selectedAssets = x.map((f) => f.name)
    let Assets = selectedAssets.join();
    //console.log(Assets);
    if (Formvalue.customername == "" || Formvalue.customername == null || Formvalue.customername == undefined) {
      ToastError("Fill the customer field");
    }
    else {
      let changes = `UpdateUserSubmit/firstname:${formObjData.firstName},
    lastname:${formObjData.lastName},
    role:${formObjData.role},
    service:${formObjData.service.join(',')},
    assectType:${formObjData.assetTypes.join(',')},
    assets:${Assets == "" ? "All" : Assets},
    usertype:${formObjData.userType.replaceAll(' ', '_')},
    status:${formObjData.isActive},
    location:${formObjData.location.join(',')},
    equipment:${formObjData.equipment.join(',')},
    contract:${contract},
    customername:${Formvalue.customername}`;

      formObjData.changes = changes;
      dispatch({ type: LOADING, payload: true });
      event.preventDefault();
      const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `User`;
      putRequest(url, formObjData)
        .then((res) => {
          if (res.status == 200) {
            ToastSuccess("updated successfully");
            dispatch({ type: LOADING, payload: false });
            //history.push("/dashboard/admin");

          } else {
            ToastError(res.data.message);
            dispatch({ type: LOADING, payload: false });
          }
        })
        .catch((error) => {
          //console.log(error);
          dispatch({ type: LOADING, payload: false });
          ToastError(error.response.data.message);
        });
      //console.log(formObj);
      // }
    }
  };

  const onChangeText = (event) => {
    //
    formObj[event.target.name] = event.target.value;
    formObj['userType'] = event.target.name == "role" && event.target.value == "ClientAdmin" ? "Client Admin" : formObj.userType
    var hasAnySpace = /\s/.test(formObj.email || formObj.firstName || formObj.lastName);
    if (hasAnySpace) {
      ToastError("Cannot Enter Space");
    }
   
    setFormObj({ ...formObj });
    // if (event.target.name == "role" && event.target.value == "ClientAdmin") {
    //   setFormObj({ ...formObj, userType: event.target.value })
    // }
  };

  const onChangeStatus = (event) => {
    setFormObj({ ...formObj, [event.target.name]: event.target.value === "Active" ? true : false });
  };

  const getUserTypes = async () => {
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `PickList/usertypes`;
    await getRequest(url)
      .then((res) => {
        //debuuger
        if (res.status == 200) {
          let arr = res.data
          const arr1 = arr.filter(item => item.usertype1 !== 'Asset Manager' && item.usertype1 !== 'Company Manager' && item.usertype1 !== 'Contract Administrator' && item.usertype1 !== 'Contract Managers');
          console.log(arr1);
          setUserTypeDetails(arr1);
        } else {
          ToastError(res.message);
        }
      })
      .catch((error) => {
        //console.log(error);
        // ToastError(error.response.data.message);
      });
  }

  const getUserByEmail = async (email) => {
    //console.log(email,'email..')
    //
    if (email) {
      const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `user/${email}`;
      await getRequest(url)
        .then(async (res) => {
          if (res.status == 200) {
            const res_user_obj = res.data;
            const res_user = { ...res_user_obj, equipment: [] };
            if (res_user.customerKeys.length) {

              await getCustomers(res_user.customerKeys);
              await getContracts(res_user.customerKeys);
            }

            if (res_user.customerKeys.length && res_user.contractKeys.length && res_user.assetTypes.length) {
              await getLocation(res_user.customerKeys, res_user.contractKeys, res_user.assetTypes);
            }

            if (res_user.customerKeys.length && res_user.contractKeys.length && res_user.assetTypes.length) {
              await getAssets(res_user.customerKeys, res_user.contractKeys, res_user.assetTypes, res_user.location);
            }

            if (res_user.customerKeys.length && res_user.contractKeys.length) {
              await getServices(res_user.customerKeys, res_user.contractKeys, res_user.location);
            }

            let assetName = [];
            if (res_user.customerKeys.length && res_user.contractKeys.length && res_user.assetTypes.length) {
              assetName = res_user.assets.map((obj) => { return obj.key; });
              let indexAsset = assetName.indexOf(-1);
              await getEquipments(res_user.customerKeys, res_user.contractKeys, res_user.assetTypes, indexAsset > -1 ? ['All'] : assetName);
            }

            setBreadcrumbList([
              { name: "Admin Panel", url: "/dashboard/admin" },
              { name: "Update User", url: "" },
            ])
            setFormAction("edit");

            let indexAsset = assetName.indexOf(-1);
            //;
            setFormObj({ ...res_user_obj, assets: indexAsset > -1 ? ['All'] : res_user.assets, created_date: '' });
          } else {
            ToastError(res.message);
          }
        })
        .catch((error) => {
          //console.log(error);
          // ToastError(error.response.data.message);
        });

    } else {
      setFormObj({
        ...formObj, customerKeys: [], contractKeys: [],
        assetTypes: ['All'],
        location: [],
        assets: [],
        assetsName: [],
        service: [],
        equipment: [], created_date: todayDate()
      })
    }
  }

  const getCustomers = async (custKey) => {
    //debuuger
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Customer`;
    await getRequest(url)
      .then(async (res) => {
        if (res.status == 200) {
          if (custKey) {
            let custObj = [];
            await res.data.map((obj) => {
              let selectVal = custKey.indexOf(obj.customerKey);
              if (selectVal > -1) {
                custObj.push(obj);
              }
            })
            setCustomerDetails(custObj);

            let userFullnames = custObj.map(function (element) {
              return `${element.customerName}`;
            })
            let customernamevalue = userFullnames.toString()
            let changed = { ...Formvalue, customername: customernamevalue };
            setFormvalue({ ...changed });
          }
        } else {
          ToastError(res.message);
        }
      })
      .catch((error) => {
        //console.log(error);
        // ToastError(error.response.data.message);
      });
  }

  const getContracts = async (customerKeys) => {
    //console.log(customerKeys,"customerKeys")
    //
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Contract`;
    const data = {
      customerKeys: customerKeys.toString()
    }
    await postRequest(url, data)
      .then((res) => {
        //console.log(res);
        if (res.status == 200) {
          let obj = { axContractId: "All", contractKey: -1 };
          let result = res.data;
          result.unshift(obj);
          setContractDetails(result);
          //SelectedContractDropdown
          //   let a=
          //   let z=SelectedContractDropdown.forEach((ele)=>{
          //     result.forEach((c)=>{
          //         if(c.key===ele){
          //             a.push(c)
          //         }
          //     })
          // })
          let userFullnames1 = result.map(function (element) {
            return `${element.axContractId}`;
          })
          let contract = userFullnames1.toString()

          let contractchanged = { ...Formvalue1, contract: contract };
          setFormvalue1({ ...contractchanged });

          // let userFullnames = result.map(function (element) {

          //   return `${element.customerName}`;
          // })
          // let remove = userFullnames.shift();
          // let hi = userFullnames.toString()
          // let changed = { ...Formvaluecustomer, customername: hi };
          // setFormvaluecustomer({ ...changed });


          // onSeletDropdown('contract',res.data);
        } else {
          ToastError(res.message);
        }
      })
      .catch((error) => {
        //console.log(error);
        // ToastError(error.response.data.message);
      });
  }

  const getAssettypes = async () => {
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `PickList/assettypes`;
    await getRequest(url)
      .then((res) => {
        //console.log(res);
        if (res.status == 200) {
          let obj = { id: "All", title: "All" };
          let result = res.data;
          result.unshift(obj);
          setAssettypeDetails(result);
          // onSeletDropdown('assettype',res.data);
        } else {
          ToastError(res.message);
        }
      })
      .catch((error) => {
        //console.log(error);
        // ToastError(error.response.data.message);
      });
  }

  const getLocation = async (customerkeys, contractKeys, assettypes) => {
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Location`;
    const data = {
      customerKeys: customerkeys.toString(),
      contractKeys: contractKeys.toString(),
      assettypes: assettypes.toString()
    }
    await postRequest(url, data)
      .then((res) => {
        //console.log(res);
        if (res.status == 200) {
          let obj = { location: "All" };
          let result = res.data;
          result.unshift(obj);
          setLocationDetails(result);
          // onSeletDropdown('location',res.data);
        } else {
          ToastError(res.message);
        }
      })
      .catch((error) => {
        //console.log(error);
        // ToastError(error.response.data.message);
      });
  }

  const getAssets = async (customerkeys, contractKeys, assettypes, locations) => {
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `PickList/assets/${customerkeys.toString()}/${contractKeys.toString()}/${assettypes.toString()}/${locations.toString()}`;
    await getRequest(url)
      .then((res) => {
        //console.log(res);
        if (res.status == 200) {
          let obj = ['All'];
          res.data.map((item) => {
            if (item.name) {
              obj.push(item);
            }
          });
          setAssetDetails(obj);
        } else {
          ToastError(res.message);
        }
      })
      .catch((error) => {
        //console.log(error);
        // ToastError(error.response.data.message);
      });
  }

  const getServices = async (customerkeys, contractKeys, locations) => {
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `PickList/services/${customerkeys}/${contractKeys}/${locations}`;
    await getRequest(url)
      .then((res) => {
        //console.log(res);
        if (res.status == 200) {
          let obj = { "product": "All" };
          let result = res.data;
          result.unshift(obj);
          setServiceDetails(result);
        } else {
          ToastError(res.message);
        }
      })
      .catch((error) => {
        //console.log(error);
        // ToastError(error.response.data.message);
      });
  }

  const getEquipments = async (customerkeys, contractKeys, assettypes, vesselKeys) => {
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Ship/AdminEquipments`;
    const data = {
      customerKeys: customerkeys.toString(),
      contractKeys: contractKeys.toString(),
      vesselKeys: vesselKeys.toString(),
      assettypes: assettypes.toString()
    }
    // const data = {
    //   "customerKeys": "32884913",
    //   "contractKeys": "5151687",
    //   "vesselKeys": "ENGIADINA",
    //   "assettypes": "Vessels"
    // }
    await postRequest(url, data)
      .then((res) => {
        //console.log(res);
        if (res.status == 200) {
          let obj = { "machineryUsageType": "All" };
          let result = res.data;
          result.unshift(obj);
          setEquipmentDetails(result);
        } else {
          ToastError(res.message);
        }
      })
      .catch((error) => {
        //console.log(error);
        // ToastError(error.response.data.message);
      });
  }

  // //console.log(formObj);
  ////;
  return (

    
    <Box height={1}>
      <Dialog
                open={openform}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                className={classes.dialogbox}
                fullWidth={fullWidth}
                fullScreen={true}
              >
                <DialogContent>
                  <DialogContentText
                    id="scroll-dialog-description"
                    //ref={descriptionElementRef}
                    tabIndex={-1}
                  >
                      <p className="subtitle">Access Role Screens Help Document</p><br />
                    <HelpChart/>
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClickClose}>Close</Button>
                </DialogActions>
              </Dialog>

      <Box component="main" mx={3} mt={3} height={1}>
        <Box className={classes.boxLayout} height={1}>
          <Box
            display="dlock"
            bgcolor="#1a1a31"
            className={classes.breadcrumbBox}
          >
            <BreadcrumbPage rows={BreadcrumbList} />
          </Box>
          <Box
            display="flex"
            className={classesCommonCss.justifyContentBetween}
            alignItems="center"
            px={3}
            pt={3}
            pb={5}
          >
            <form onSubmit={formAction === "add" ? addUserSubmit : updateUserSubmit}>
              <Grid container spacing={3} className="add-user">
                <Grid item xs={12} sm={12} md={12}>
                  <Box component="h1" my={0}  >
                    User Information
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={3}>
                  <Box component="label"  >
                    First Name
                  </Box>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    name="firstName"
                    value={formObj.firstName}
                    className={classes.txtInput}
                    placeholder="Type"
                    onChange={onChangeText}
                  // onChange={(e) => setPass(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3}>
                  <Box component="label"  >
                    Last Name
                  </Box>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    name="lastName"
                    value={formObj?.lastName}
                    className={classes.txtInput}
                    placeholder="Type"
                    onChange={onChangeText}
                  // onChange={(e) => setPass(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3}>
                  <Box component="label"  >
                    Email
                  </Box>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    InputProps={{
                      readOnly: (formAction == 'edit' ? true : false)
                    }}
                    name="email"
                    // disabled={formAction==="add"?false:true}
                    className={classes.txtInput, formAction == 'edit' ? classes.readonlyTxt : ''}
                    placeholder="Type"
                    value={formObj.email || ""}
                    onChange={onChangeText}

                  // onChange={(e) => setPass(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3}>
                  <Box component="label" >
                    Date Created
                  </Box>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    InputProps={{
                      readOnly: (formAction == 'edit' ? true : false),
                    }}
                    // readOnly={formAction == 'edit'?true:false}
                    fullWidth
                    name="created_date"
                    value={formObj.created_date || ""}
                    className={classes.txtInput, formAction == 'edit' ? classes.readonlyTxt : ''}
                    placeholder="Create Date"
                    onChange={onChangeText}
                  // onChange={(e) => setPass(e.target.value)}
                  />
                </Grid>

                <Grid item xs={6} sm={6} md={3}>
                  {getCookie("type") == "VPS Admin" ? (
                    <React.Fragment>
                      <Box component="label"  >
                        Status
                      </Box>
                      <Box display="block" pt={0.5}>
                        <RadioGroup
                          aria-label="Status"
                          name="isActive"
                          value={formObj.isActive ? "Active" : "Inactive"}
                          onChange={onChangeStatus}
                        >
                          <Box
                            display="flex"
                            alignItems="center"
                            className={classes.radioInput}
                          >
                            <FormControlLabel
                              value="Active"
                              control={<Radio />}
                              label="Active"
                            />
                            <FormControlLabel
                              value="Inactive"
                              control={<Radio />}
                              label="Inactive"
                            />
                          </Box>
                        </RadioGroup>
                      </Box>
                    </React.Fragment>
                  ) : ""}</Grid>
                {/* <Grid item xs={6} sm={6} md={6}>
                  {formAction != "add" ? (
                    <React.Fragment>
                      <Box component="label"  >
                        <p><b>{"Access Role :"}</b>{getCookie("type")}</p>
                      </Box>
                      <br></br>
                      <Box component="label"  >
                        <p><b>{"Client Name :"}</b>{getCookie("clientName")}</p>
                      </Box>

                    </React.Fragment>
                  ) : ""}</Grid> */}
              </Grid>
              <Grid container spacing={3} className="user-role">
                <Grid item xs={12} sm={12} md={3} >
                  <Box component="label" >
                    Role
                  </Box>
                  <Box display="block" pt={0.5}>
                    <RadioGroup
                      aria-label="Role"
                      name="role"
                      value={formObj.role}
                      onChange={onChangeText}
                    >
                      <Box

                        className={classes.radioInput}
                      >
                        <FormControlLabel
                          value="ClientUser"
                          control={<Radio />}
                          label="Client User"
                        />
                        {getCookie("userRole") == "VPS Admin" ? (<FormControlLabel
                          value="ClientAdmin"
                          control={<Radio />}
                          label="Client Admin"
                        />) : ""}
                      </Box>
                    </RadioGroup>
                  </Box>
                </Grid>

                {formObj.role == "ClientUser" ? <Grid item xs={12} sm={12} md={9} className="user-access">
                  <Box component="label"  >
                    Access Role
                  </Box>
                  <IconButton aria-label="Help" style={{marginBottom:"2px"}}>
                  {/* <Help  style={{fontSize:"23px",cursor:"pointer",color:"#FF4717"}} onClick={handleClickOpenForm}/> */}
                  </IconButton>
                  <Box display="block" pt={0.5}>
                    <RadioGroup
                      aria-label="userType"
                      name="userType"
                      value={formObj.userType}
                      onChange={onChangeText}
                    >
                      <Box className={classes.radioInput}
                      >
                        {
                          userTypeDetails.length ? userTypeDetails.map((obj) => {
                            return (
                              <FormControlLabel
                                value={obj.usertype1}
                                control={<Radio />}
                                label={obj.usertype1}
                              />
                            )
                          }) : ""
                        }
                      </Box>
                    </RadioGroup>
                  </Box>
                </Grid>
                  : ""}
              </Grid>
              <Grid container spacing={3} className="user-customer">

                <Grid item xs={12} lg={6}>
                  <Box mb={0.5} fontWeight={600}>
                    Customer
                  </Box>
                  <Box display="flex">
                    <Box width={0.4}>
                      <Box
                        display="inline"
                        width={0.9}
                        className={classes.mainSelectDropdown}
                      >
                        <Box
                          display="flex"
                          color="#7a7a7a"
                          position="relative"
                          className={classesCommonCss.justifyContentBetween}
                        >
                          <Box>Select</Box>
                          <Box>
                            <ExpandLessIcon
                              onClick={() => {
                                setCustomerDropdown("close");
                              }}
                              className={clsx(
                                customerDropdown == "open"
                                  ? (classes.dropdownActive, classes.iconSelect)
                                  : classes.dropdownInactive
                              )}
                            />
                            <ExpandMoreIcon
                              onClick={() => {
                                setCustomerDropdown("open");
                              }}
                              className={
                                customerDropdown == "close"
                                  ? (classes.dropdownActive, classes.iconSelect)
                                  : classes.dropdownInactive
                              }
                            />
                          </Box>
                        </Box>
                        <Box
                          display="block"
                          className={
                            customerDropdown == "open"
                              ? classes.dropdownActive
                              : classes.dropdownInactive
                          }
                          pt={1}

                        >
                          <Box className={classes.formControl}>
                            <Autocomplete
                              id="combo-box-demo"
                              options={customerDetailsBySearch}
                              name="contractKeys"
                              inputValue={valueCustomer}
                              onInputChange={(event, newInputValue) => {
                                //console.log(newInputValue);
                                // if(newInputValue){
                                //   //console.log(newInputValue,"inn");
                                //   let arrCustomer = [];
                                //   arrCustomer.push(newInputValue);
                                //   setFormObj({ ...formObj, ["customerKeys"]:arrCustomer})
                                // }  else {

                                // setFormObj({ ...formObj, ["customerKeys"]:[]})
                                // }
                              }}
                              // value={formObj.customerKeys[0]}
                              onChange={(event, newValue) => {
                                //debuuger
                                if (newValue) {
                                  let arrCustomer = formObj.customerKeys;
                                  let arrCustomerName = customerDetails;
                                  if (arrCustomer.indexOf(newValue.customerKey) == -1) {
                                    arrCustomerName.push(newValue);
                                    arrCustomer.push(newValue.customerKey);
                                    // //console.log(JSON.stringify(arrCustomerName));
                                    let res = [];
                                    let resName = [];
                                    arrCustomerName.map((x) => {
                                      if (resName.indexOf(x.customerKey) == -1) {
                                        resName.push(x.customerKey)
                                        res.push(x);
                                      }
                                    })
                                    // //console.log(JSON.stringify(res));
                                    setCustomerDetails(res);
                                  }
                                  let numberVal = [-1];
                                  let stringVal = ['All'];
                                  setContractDetails([]);
                                  setLocationDetails([]);
                                  setAssetDetails([]);
                                  setServiceDetails([]);
                                  setEquipmentDetails([]);
                                  setFormObj({ ...formObj, ["customerKeys"]: arrCustomer, ["contractKeys"]: numberVal, ["location"]: stringVal, ["assets"]: stringVal, ["service"]: stringVal, ['equipment']: stringVal });
                                  getCustomers(arrCustomer);
                                  getContracts(arrCustomer);
                                  getLocation(arrCustomer, numberVal, stringVal);
                                  getAssets(arrCustomer, numberVal, stringVal, stringVal);
                                  getServices(arrCustomer, numberVal, stringVal);
                                  getEquipments(arrCustomer, numberVal, stringVal, stringVal);
                                } else {
                                  // setContractDetails([]);
                                  // setFormObj({ ...formObj, ["customerKeys"]:[]})
                                }
                              }}
                              getOptionLabel={(option) => option.customerName}
                              // style={{ width: 300 }}
                              renderInput={(params) => <TextField {...params}
                                onChange={autoTextCustomer}
                                label="" className={clsx(classes.autoTextbox)} />}
                            />
                            {/* <Box
                              className={clsx(
                                classes.selectDropdown,

                                "scroll-bar"
                              )}
                              // onChange={handleChangeMultiple}
                            >
                              {customerDetails.length?customerDetails.map((obj) => {
                                let selectVal = formObj.customerKeys.indexOf(obj.customerKey);
                                return (
                                  <Box
                                    key={obj.customerKey}
                                    className={clsx(
                                      selectVal > -1
                                        ? classes.selectDropdownActive
                                        : classes.selectDropdownInactive,
                                      classesCommonCss.justifyContentBetween,
                                      classesCommonCss.cursorPointer
                                    )}
                                    display="flex"
                                    onClick={() => {
                                      onMultiSelect(
                                        "customer",
                                        formObj.customerKeys,
                                        obj,
                                        obj.customerKey
                                      );
                                    }}
                                  >
                                    <Box>{obj.customerName}</Box>
                                    <Box
                                      display={
                                        selectVal > -1 ? "block" : "none"
                                      }
                                      component="img"
                                      width="16px"
                                      mr={1}
                                      src="/assets/svg/check.svg"
                                    />
                                  </Box>
                                );
                              }):""}
                            </Box> */}
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box width={0.5}>
                      {/* {customerDetailsBySearch[0].customerName} */}
                      {customerDetails.length ? customerDetails.map((obj) => {
                        //
                        let selectVal = formObj.customerKeys.indexOf(obj.customerKey);
                        //console.log(selectVal,'obj key',formObj.customerKeys, customerDetails);

                        return (
                          <React.Fragment
                            key={obj.customerKey}>
                            {selectVal > -1 ? (
                              <Box
                                component="span"
                                className={classes.seletedItem}
                              >
                                <Box component="span">{obj.customerName}</Box>
                                <Box
                                  className={classesCommonCss.cursorPointer}
                                  component="img"
                                  width="8px"
                                  ml={0.5}
                                  onClick={(event) => {
                                    //debuuger
                                    if(formObj.customerKeys.length == 1 ){
                                     setCustomerDetails([]) 
                                    }
                                    //setCustomerDetails([])
                                    onMultiSelect(
                                      "customer",
                                      formObj.customerKeys,
                                      obj,
                                      obj.customerKey
                                    );
                                  }}
                                  src="/assets/svg/close.svg"
                                />
                              </Box>
                            ) : ""}
                          </React.Fragment>
                        )
                      }) : ""}
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} lg={6}>
                  <Box width={0.36}>
                    <Box display="flex" className={classesCommonCss.justifyContentBetween}>
                      <Box mb={0.5} fontWeight={600}>
                        Contract
                      </Box>
                      <Box>
                        {/* <CloseIcon onClick={()=>{
                        onClearDropdown('contract');
                      }} />  */}
                        <DoneIcon onClick={() => {
                          onSeletDropdown('contract', contractDetails);
                        }} /></Box>
                    </Box>
                  </Box>
                  <Box display="flex">
                    <Box width={0.4}>
                      <Box
                        display="inline"
                        width={0.9}
                        className={classes.mainSelectDropdown}
                      >
                        <Box
                          display="flex"
                          color="#7a7a7a"
                          position="relative"
                          className={classesCommonCss.justifyContentBetween}
                        >
                          <Box>Select</Box>
                          <Box>
                            <ExpandLessIcon
                              onClick={() => {
                                setContractDropdown("close");
                              }}
                              className={clsx(
                                contractDropdown == "open"
                                  ? (classes.dropdownActive, classes.iconSelect)
                                  : classes.dropdownInactive
                              )}
                            />
                            <ExpandMoreIcon
                              onClick={() => {
                                setContractDropdown("open");
                              }}
                              className={
                                contractDropdown == "close"
                                  ? (classes.dropdownActive, classes.iconSelect)
                                  : classes.dropdownInactive
                              }
                            />
                          </Box>
                        </Box>
                        <Box
                          display="block"
                          className={
                            contractDropdown == "open"
                              ? classes.dropdownActive
                              : classes.dropdownInactive
                          }
                          pt={1}
                        >
                          <Box className={classes.formControl}>
                            <Box
                              className={clsx(
                                classes.selectDropdown1,

                                "scroll-bar1"
                              )}
                            // onChange={handleChangeMultiple}
                            >
                              <Box component="span">
                                <List className="scroll-bar list-multi-dropdown"
                                  width={230}
                                  height={100}
                                  rowCount={contractDetails.length}
                                  rowHeight={20}
                                  rowRenderer={(props) => {
                                    const {
                                      key, index, isScrolling, isVisible, style,
                                    } = props
                                    let selectVal = formObj.contractKeys.indexOf(contractDetails[index].contractKey);
                                    // //console.log(selectVal, contractDetails[index].contractKeys, formObj.contractKey);
                                    return (
                                      <div key={key} style={style} onClick={() => {
                                        onMultiSelect(
                                          "contract",
                                          formObj.contractKeys,
                                          contractDetails[index],
                                          contractDetails[index].contractKey
                                        );
                                      }} className={clsx(
                                        selectVal > -1
                                          ? classes.selectDropdownActive
                                          : classes.selectDropdownInactive,
                                        // contractDetails[index].contractKey === -1 && formObj.contractKeys.length == 0
                                        //   ? classes.selectDropdownActive
                                        //   : classes.selectDropdownInactive,
                                        classesCommonCss.justifyContentBetween,
                                        classesCommonCss.cursorPointer
                                      )} title={contractDetails[index].axContractId}>
                                        {contractDetails[index].axContractId ? (<EllipsisText
                                          text={contractDetails[index].axContractId}
                                          length={"30"} />) : ""}
                                      </div>
                                    );
                                  }}
                                  length={"5"}
                                > </List> </Box>
                              {/* {contractDetails.length?contractDetails.map((obj) => {
                                let selectVal = formObj.contractKeys.indexOf(obj.contractKey);
                                return (
                                  <Box
                                    key={obj.contractKey}
                                    className={clsx(
                                      selectVal > -1
                                        ? classes.selectDropdownActive
                                        : classes.selectDropdownInactive,
                                      classesCommonCss.justifyContentBetween,
                                      classesCommonCss.cursorPointer
                                    )}
                                    display="flex"
                                    onClick={() => {
                                      onMultiSelect(
                                        "contract",
                                        formObj.contractKeys,
                                        obj,
                                        obj.contractKey
                                      );
                                    }}
                                  >
                                    <Box>{obj.axContractId}</Box>
                                    <Box
                                      display={
                                        selectVal > -1 ? "block" : "none"
                                      }
                                      component="img"
                                      width="16px"
                                      mr={1}
                                      src="/assets/svg/check.svg"
                                    />
                                  </Box>
                                );
                              }):""} */}
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box width={0.5}>
                      {contractDetails.length ? contractDetails.map((obj) => {
                        let selectVal = formObj.contractKeys.indexOf(obj.contractKey);
                        return (
                          <React.Fragment key={obj.contractKey}>
                            {selectVal > -1 ? (
                              <Box
                                component="span"
                                className={classes.seletedItem}
                              >
                                <Box component="span">{obj.axContractId}</Box>
                                <Box
                                  className={classesCommonCss.cursorPointer}
                                  component="img"
                                  width="8px"
                                  ml={0.5}
                                  onClick={() => {
                                    onMultiSelect(
                                      "contract",
                                      formObj.contractKeys,
                                      obj,
                                      obj.contractKey
                                    );
                                  }}
                                  src="/assets/svg/close.svg"
                                />
                              </Box>
                            ) : ""}
                          </React.Fragment>
                        )
                      }) : ""}
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} lg={6}>
                  <Box width={0.36}>
                    <Box display="flex" className={classesCommonCss.justifyContentBetween}>
                      <Box mb={0.5} fontWeight={600}>
                        Asset Type
                      </Box>
                      <Box>
                        {/* <CloseIcon onClick={()=>{
                        onClearDropdown('assettype');
                      }} />  */}
                        <DoneIcon onClick={() => {
                          onSeletDropdown('assettype', assettypeDetails);
                        }} /></Box>
                    </Box>
                  </Box>

                  <Box display="flex">
                    <Box width={0.4}>
                      <Box
                        display="inline"
                        width={0.9}
                        className={classes.mainSelectDropdown}
                      >
                        <Box
                          display="flex"
                          color="#7a7a7a"
                          position="relative"
                          className={classesCommonCss.justifyContentBetween}
                        >
                          <Box>Select</Box>
                          <Box>
                            <ExpandLessIcon
                              onClick={() => {
                                setAssettypeDropdown("close");
                              }}
                              className={clsx(
                                assettypeDropdown == "open"
                                  ? (classes.dropdownActive, classes.iconSelect)
                                  : classes.dropdownInactive
                              )}
                            />
                            <ExpandMoreIcon
                              onClick={() => {
                                setAssettypeDropdown("open");
                              }}
                              className={
                                assettypeDropdown == "close"
                                  ? (classes.dropdownActive, classes.iconSelect)
                                  : classes.dropdownInactive
                              }
                            />
                          </Box>
                        </Box>
                        <Box
                          display="block"
                          className={
                            assettypeDropdown == "open"
                              ? classes.dropdownActive
                              : classes.dropdownInactive
                          }
                          pt={1}
                        >
                          <Box className={classes.formControl}>
                            <Box
                              className={clsx(
                                classes.selectDropdown,

                                "scroll-bar"
                              )}
                            // onChange={handleChangeMultiple}
                            >
                              {assettypeDetails.length ? assettypeDetails.map((obj) => {
                                let selectVal = formObj.assetTypes.indexOf(obj.title);
                                return (
                                  <Box
                                    key={obj.id}
                                    className={clsx(
                                      selectVal > -1
                                        ? classes.selectDropdownActive
                                        : classes.selectDropdownInactive,
                                      classesCommonCss.justifyContentBetween,
                                      classesCommonCss.cursorPointer
                                    )}
                                    display="flex"
                                    onClick={() => {
                                      onMultiSelect(
                                        "assettype",
                                        formObj.assetTypes,
                                        obj,
                                        obj.title
                                      );
                                    }}
                                  >
                                    <Box>{obj.title}</Box>
                                    <Box
                                      display={
                                        selectVal > -1 ? "block" : "none"
                                      }
                                      component="img"
                                      width="16px"
                                      mr={1}
                                      src="/assets/svg/check.svg"
                                    />
                                  </Box>
                                );
                              }) : ""}
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box width={0.5}>
                      {assettypeDetails.length ? assettypeDetails.map((obj) => {
                        let selectVal = formObj.assetTypes.indexOf(obj.title);
                        return (
                          <React.Fragment key={obj.id}>
                            {selectVal > -1 ? (
                              <Box
                                component="span"
                                className={classes.seletedItem}
                              >
                                <Box component="span">{obj.title}</Box>
                                <Box
                                  className={classesCommonCss.cursorPointer}
                                  component="img"
                                  width="8px"
                                  ml={0.5}
                                  onClick={() => {
                                    onMultiSelect(
                                      "assettype",
                                      formObj.assetTypes,
                                      obj,
                                      obj.title
                                    );
                                  }}
                                  src="/assets/svg/close.svg"
                                />
                              </Box>
                            ) : ""}
                          </React.Fragment>
                        )
                      }) : ""}
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} lg={6}>
                  <Box width={0.36}>
                    <Box display="flex" className={classesCommonCss.justifyContentBetween}>
                      <Box mb={0.5} fontWeight={600}>
                        Location
                      </Box>
                      <Box>
                        {/* <CloseIcon onClick={()=>{
                        onClearDropdown('location');
                      }} />  */}
                        <DoneIcon onClick={() => {
                          onSeletDropdown('location', locationDetails);
                        }} /></Box>
                    </Box>
                    <Box display="flex"
                      className={classes.searchTxt}>
                      <TextField
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        name="searchLocation"
                        // value={formObj.searchLocation || ""}
                        className={classes.txtInput}
                        placeholder="Search Location"
                        onChange={(event) => {
                          onChangeSearchText(event.target.value, event.target.name);
                        }}
                      />
                    </Box>
                  </Box>
                  <Box display="flex">
                    <Box width={0.4}>
                      <Box
                        display="inline"
                        width={0.9}
                        className={classes.mainSelectDropdown}
                      >
                        <Box
                          display="flex"
                          color="#7a7a7a"
                          position="relative"
                          className={classesCommonCss.justifyContentBetween}
                        >
                          <Box>Select</Box>
                          <Box>
                            <ExpandLessIcon
                              onClick={() => {
                                setLocationDropdown("close");
                              }}
                              className={clsx(
                                locationDropdown == "open"
                                  ? (classes.dropdownActive, classes.iconSelect)
                                  : classes.dropdownInactive
                              )}
                            />
                            <ExpandMoreIcon
                              onClick={() => {
                                setLocationDropdown("open");
                              }}
                              className={
                                locationDropdown == "close"
                                  ? (classes.dropdownActive, classes.iconSelect)
                                  : classes.dropdownInactive
                              }
                            />
                          </Box>
                        </Box>
                        <Box
                          display="block"
                          className={
                            locationDropdown == "open"
                              ? classes.dropdownActive
                              : classes.dropdownInactive
                          }
                          pt={1}
                        >
                          <Box className={classes.formControl}>
                            <Box
                              className={clsx(
                                classes.selectDropdown1,

                                "scroll-bar1"
                              )}
                            // onChange={handleChangeMultiple}
                            >
                              <Box component="span">
                                <List className="scroll-bar  list-multi-dropdown"
                                  width={230}
                                  height={100}
                                  rowCount={locationDetails.length}
                                  rowHeight={20}
                                  rowRenderer={(props) => {
                                    const {
                                      key, index, isScrolling, isVisible, style,
                                    } = props
                                    let selectVal = formObj.location.indexOf(locationDetails[index].location);
                                    ////console.log(selectVal, locationDetails[index].location, formObj.location);
                                    return (
                                      <div key={key} style={style} onClick={() => {
                                        onMultiSelect(
                                          "location",
                                          formObj.location,
                                          locationDetails[index],
                                          locationDetails[index].location.toString()
                                        );
                                      }} className={clsx(
                                        selectVal > -1
                                          ? classes.selectDropdownActive
                                          : classes.selectDropdownInactive,
                                        classesCommonCss.justifyContentBetween,
                                        classesCommonCss.cursorPointer
                                      )} title={locationDetails[index].location}>
                                        {locationDetails[index].location ? (<EllipsisText
                                          text={locationDetails[index].location}
                                          length={"30"} />) : ''}
                                      </div>
                                    );
                                  }}
                                  length={"5"}
                                > </List> </Box>
                              {/* {locationDetails.length? locationDetails.map((obj) => {
                                let selectVal = formObj.location.indexOf(obj.location);
                                return (
                                  <Box
                                    key={obj.location}
                                    className={clsx(
                                      selectVal > -1
                                        ? classes.selectDropdownActive
                                        : classes.selectDropdownInactive,
                                      classesCommonCss.justifyContentBetween,
                                      classesCommonCss.cursorPointer
                                    )}
                                    display="flex"
                                    onClick={() => {
                                      onMultiSelect(
                                        "location",
                                        formObj.location,
                                        obj,
                                        obj.location.toString()
                                      );
                                    }}
                                  >
                                    <Box>{obj.location}</Box>
                                    <Box
                                      display={
                                        selectVal > -1 ? "block" : "none"
                                      }
                                      component="img"
                                      width="16px"
                                      mr={1}
                                      src="/assets/svg/check.svg"
                                    />
                                  </Box>
                                );
                              }):""} */}
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box width={0.5}>
                      {locationDetails.length ? locationDetails.map((obj) => {
                        let selectVal = formObj.location.indexOf(obj.location);
                        return (
                          <React.Fragment key={obj.location}>
                            {selectVal > -1 ? (
                              <Box
                                component="span"
                                className={classes.seletedItem}
                              >
                                <Box component="span">{obj.location}</Box>

                                <Box
                                  className={classesCommonCss.cursorPointer}
                                  component="img"
                                  width="8px"
                                  ml={0.5}
                                  onClick={() => {
                                    onMultiSelect(
                                      "location",
                                      formObj.location,
                                      obj,
                                      obj.location.toString()
                                    );
                                  }}
                                  src="/assets/svg/close.svg"
                                />
                              </Box>
                            ) : ""}
                          </React.Fragment>
                        )
                      }) : ""}
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} lg={6}>
                  <Box width={0.36}>
                    <Box display="flex" className={classesCommonCss.justifyContentBetween}>
                      <Box mb={0.5} fontWeight={600}>
                        Assets
                      </Box>
                      <Box>
                        {/* <CloseIcon onClick={()=>{
                        onClearDropdown('assets');
                      }} />  */}
                        <DoneIcon onClick={() => {
                          onSeletDropdown('assets', assetDetails);
                        }} /></Box>
                    </Box>
                    <Box display="flex" className={classes.searchTxt}>
                      <TextField
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        name="searchAssets"
                        // value={formObj.searchAssets || ""}
                        className={classes.txtInput}
                        placeholder="Search Assets"
                        onChange={(event) => {
                          // setFormObj({...formObj, [event.target.name]:event.target.value})
                          onChangeSearchText(event.target.value, event.target.name);
                        }}
                      />
                    </Box>
                  </Box>
                  <Box display="flex">
                    <Box width={0.4}>
                      <Box
                        display="inline"
                        width={0.9}
                        className={classes.mainSelectDropdown}
                      >
                        <Box
                          display="flex"
                          color="#7a7a7a"
                          position="relative"
                          className={classesCommonCss.justifyContentBetween}
                        >
                          <Box>Select</Box>
                          <Box>
                            <ExpandLessIcon
                              onClick={() => {
                                setAssetDropdown("close");
                              }}
                              className={clsx(
                                assetDropdown == "open"
                                  ? (classes.dropdownActive, classes.iconSelect)
                                  : classes.dropdownInactive
                              )}
                            />
                            <ExpandMoreIcon
                              onClick={() => {
                                setAssetDropdown("open");
                              }}
                              className={
                                assetDropdown == "close"
                                  ? (classes.dropdownActive, classes.iconSelect)
                                  : classes.dropdownInactive
                              }
                            />
                          </Box>
                        </Box>
                        <Box
                          display="block"
                          className={
                            assetDropdown == "open"
                              ? classes.dropdownActive
                              : classes.dropdownInactive
                          }
                          pt={1}
                        >
                          <Box className={classes.formControl}>
                            <Box
                              className={clsx(
                                classes.selectDropdown1,

                                "scroll-bar1"
                              )}
                            // onChange={handleChangeMultiple}
                            >

                              {/* {assetDetails.length? assetDetails.map((obj) => {
                                let selectVal = formObj.assets.indexOf(obj);
                                return (
                                  <Box
                                    key={obj.id}
                                    className={clsx(
                                      selectVal > -1
                                        ? classes.selectDropdownActive
                                        : classes.selectDropdownInactive,
                                      classesCommonCss.justifyContentBetween,
                                      classesCommonCss.cursorPointer
                                    )}
                                    display="flex"
                                    onClick={() => {
                                      onMultiSelect(
                                        "assets",
                                        formObj.assets,
                                        obj,
                                        obj
                                      );
                                    }}
                                  >
                                    <Box>{obj.name}</Box>
                                    <Box
                                      display={
                                        selectVal > -1 ? "block" : "none"
                                      }
                                      component="img"
                                      width="16px"
                                      mr={1}
                                      src="/assets/svg/check.svg"
                                    />
                                  </Box>
                                );
                              }):""} */}
                              <Box component="span">
                                <List className="scroll-bar  list-multi-dropdown"
                                  width={230}
                                  height={100}
                                  rowCount={assetDetails.length}
                                  rowHeight={20}
                                  rowRenderer={(props) => {
                                    const {
                                      key, index, isScrolling, isVisible, style,
                                    } = props
                                    //let selectVal = formObj.assets.indexOf(assetDetails[index]);
                                    let selectVal = formObj.assets.findIndex(i => i.key == assetDetails[index]['key']);
                                    ////console.log(selectVal, assetDetails[index], formObj.assets,'asstes5');
                                    return (
                                      <React.Fragment>
                                        {(
                                          <div key={key} style={style} onClick={() => {
                                            onMultiSelect(
                                              "assets",
                                              formObj.assets,
                                              assetDetails[index],
                                              assetDetails[index]
                                            );
                                          }} className={clsx(
                                            selectVal > -1
                                              ? classes.selectDropdownActive
                                              : classes.selectDropdownInactive,
                                            classesCommonCss.justifyContentBetween,
                                            classesCommonCss.cursorPointer
                                          )}
                                            title={assetDetails[index] == "All" ? 'All' : assetDetails[index].name ? assetDetails[index].name : ''}
                                          >
                                            {
                                              assetDetails[index] == "All" ? "All" :
                                                assetDetails[index].name ? (<EllipsisText
                                                  text={assetDetails[index].name}
                                                  length={"30"} />) : ""
                                            }

                                          </div>
                                        )}
                                      </React.Fragment>
                                    );
                                  }}
                                  length={"5"}
                                > </List> </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box width={0.5}>
                      {assetDetails.length ? assetDetails.map((obj) => {
                        //let selectVal = formObj.assets.indexOf(obj);
                        let selectVal = formObj.assets.findIndex(i => i.key == obj['key']);
                        return (
                          <React.Fragment key={obj.id}>
                            {selectVal > -1 ? (
                              <Box
                                component="span"
                                className={classes.seletedItem}
                              >
                                <Box component="span">{obj == 'All' ? 'All' : obj.name}</Box>
                                <Box
                                  className={classesCommonCss.cursorPointer}
                                  component="img"
                                  width="8px"
                                  ml={0.5}
                                  onClick={() => {
                                    onMultiSelect(
                                      "assets",
                                      formObj.assets,
                                      obj,
                                      obj
                                    );
                                  }}
                                  src="/assets/svg/close.svg"
                                />
                              </Box>
                            ) : ""}
                          </React.Fragment>
                        )
                      }) : ""}
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} lg={6}>
                  <Box width={0.36}>
                    <Box display="flex" className={classesCommonCss.justifyContentBetween}>
                      <Box mb={0.5} fontWeight={600}>
                        Services
                      </Box>
                      <Box>
                        {/* <CloseIcon onClick={()=>{
                        onClearDropdown('services');
                      }} />  */}
                        <DoneIcon onClick={() => {
                          onSeletDropdown('services', serviceDetails);
                        }} /></Box>
                    </Box>
                    <Box display="flex"
                      className={classes.searchTxt}>
                      <TextField
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        name="searchServices"
                        // value={formObj.searchLocation || ""}
                        className={classes.txtInput}
                        placeholder="Search Services"
                        onChange={(event) => {
                          onChangeSearchText(event.target.value, event.target.name);
                        }}
                      />
                    </Box>
                  </Box>
                  <Box display="flex">
                    <Box width={0.4}>
                      <Box
                        display="inline"
                        width={0.9}
                        className={classes.mainSelectDropdown}
                      >
                        <Box
                          display="flex"
                          color="#7a7a7a"
                          position="relative"
                          className={classesCommonCss.justifyContentBetween}
                        >
                          <Box>Select</Box>
                          <Box>
                            <ExpandLessIcon
                              onClick={() => {
                                setServiceDropdown("close");
                              }}
                              className={clsx(
                                serviceDropdown == "open"
                                  ? (classes.dropdownActive, classes.iconSelect)
                                  : classes.dropdownInactive
                              )}
                            />
                            <ExpandMoreIcon
                              onClick={() => {
                                setServiceDropdown("open");
                              }}
                              className={
                                serviceDropdown == "close"
                                  ? (classes.dropdownActive, classes.iconSelect)
                                  : classes.dropdownInactive
                              }
                            />
                          </Box>
                        </Box>
                        <Box
                          display="block"
                          className={
                            serviceDropdown == "open"
                              ? classes.dropdownActive
                              : classes.dropdownInactive
                          }
                          pt={1}
                        >
                          <Box className={classes.formControl}>
                            <Box
                              className={clsx(
                                classes.selectDropdown1,

                                "scroll-bar1"
                              )}
                            // onChange={handleChangeMultiple}
                            >
                              <Box component="span">
                                <List className="scroll-bar  list-multi-dropdown"
                                  width={230}
                                  height={100}
                                  rowCount={serviceDetails.length}
                                  rowHeight={20}
                                  rowRenderer={(props) => {
                                    const {
                                      key, index, isScrolling, isVisible, style,
                                    } = props
                                    let selectVal = formObj.service.indexOf(serviceDetails[index].product);
                                    // //console.log(selectVal, serviceDetails[index].product, formObj.service, 'service6');
                                    return (
                                      <div key={key} style={style} onClick={() => {
                                        onMultiSelect(
                                          "services",
                                          formObj.service,
                                          serviceDetails[index],
                                          serviceDetails[index].product
                                        );
                                      }} className={clsx(
                                        selectVal > -1
                                          ? classes.selectDropdownActive
                                          : classes.selectDropdownInactive,
                                        classesCommonCss.justifyContentBetween,
                                        classesCommonCss.cursorPointer
                                      )} title={serviceDetails[index].product}>
                                        {serviceDetails[index].product ? (
                                          <EllipsisText
                                            text={serviceDetails[index].product}
                                            length={"30"} />
                                        ) : ''}

                                      </div>
                                    );
                                  }}
                                  length={"5"}
                                > </List> </Box>
                              {/* {serviceDetails.length? serviceDetails.map((obj) => {
                                let selectVal = formObj.service.indexOf(obj.product);
                                return (
                                  <Box
                                    key={obj.product}
                                    className={clsx(
                                      selectVal > -1
                                        ? classes.selectDropdownActive
                                        : classes.selectDropdownInactive,
                                      classesCommonCss.justifyContentBetween,
                                      classesCommonCss.cursorPointer
                                    )}
                                    display="flex"
                                    onClick={() => {
                                      onMultiSelect(
                                        "services",
                                        formObj.service,
                                        obj,
                                        obj.product
                                      );
                                    }}
                                  >
                                    <Box>{obj.product}</Box>
                                    <Box
                                      display={
                                        selectVal > -1 ? "block" : "none"
                                      }
                                      component="img"
                                      width="16px"
                                      mr={1}
                                      src="/assets/svg/check.svg"
                                    />
                                  </Box>
                                );
                              }):""} */}
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box width={0.5}>
                      {serviceDetails.length ? serviceDetails.map((obj) => {
                        let selectVal = formObj.service.indexOf(obj.product);
                        return (
                          <React.Fragment key={obj.product}>
                            {selectVal > -1 ? (
                              <Box
                                component="span"
                                className={classes.seletedItem}
                              >
                                <Box component="span">{obj.product}</Box>
                                <Box
                                  className={classesCommonCss.cursorPointer}
                                  component="img"
                                  width="8px"
                                  ml={0.5}
                                  onClick={() => {
                                    onMultiSelect(
                                      "services",
                                      formObj.service,
                                      obj,
                                      obj.product
                                    );
                                  }}
                                  src="/assets/svg/close.svg"
                                />
                              </Box>
                            ) : ""}
                          </React.Fragment>
                        )
                      }) : ""}
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} lg={6}>
                  <Box width={0.36}>
                    <Box display="flex" className={classesCommonCss.justifyContentBetween}>
                      <Box mb={0.5} fontWeight={600}>
                        Equipment
                      </Box>
                      <Box>
                        {/* <CloseIcon onClick={()=>{
                        onClearDropdown('equipment');
                      }} />  */}
                        <DoneIcon onClick={() => {
                          onSeletDropdown('equipment', equipmentDetails);
                        }} /></Box>
                    </Box>
                    <Box display="flex"
                      className={classes.searchTxt}>
                      <TextField
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        name="searchEquipment"
                        // value={formObj.searchLocation || ""}
                        className={classes.txtInput}
                        placeholder="Search Equipment"
                        onChange={(event) => {
                          onChangeSearchText(event.target.value, event.target.name);
                        }}
                      />
                    </Box>
                  </Box>
                  <Box display="flex">
                    <Box width={0.4}>
                      <Box
                        display="inline"
                        width={0.9}
                        className={classes.mainSelectDropdown}
                      >
                        <Box
                          display="flex"
                          color="#7a7a7a"
                          position="relative"
                          className={classesCommonCss.justifyContentBetween}
                        >
                          <Box>Select</Box>
                          <Box>
                            <ExpandLessIcon
                              onClick={() => {
                                setEquipmentDropdown("close");
                              }}
                              className={clsx(
                                equipmentDropdown == "open"
                                  ? (classes.dropdownActive, classes.iconSelect)
                                  : classes.dropdownInactive
                              )}
                            />
                            <ExpandMoreIcon
                              onClick={() => {
                                setEquipmentDropdown("open");
                              }}
                              className={
                                equipmentDropdown == "close"
                                  ? (classes.dropdownActive, classes.iconSelect)
                                  : classes.dropdownInactive
                              }
                            />
                          </Box>
                        </Box>
                        <Box
                          display="block"
                          className={
                            equipmentDropdown == "open"
                              ? classes.dropdownActive
                              : classes.dropdownInactive
                          }
                          pt={1}
                        >
                          <Box className={classes.formControl}>
                            <Box
                              className={clsx(
                                classes.selectDropdown1,

                                "scroll-bar1"
                              )}
                            // onChange={handleChangeMultiple}
                            >
                              {/* {equipmentDetails.length? equipmentDetails.map((obj) => {
                                let selectVal = formObj.equipment.indexOf(obj.machineryUsageType);
                                return (
                                  <Box
                                    key={obj.machineryUsageType}
                                    className={clsx(
                                      selectVal > -1
                                        ? classes.selectDropdownActive
                                        : classes.selectDropdownInactive,
                                      classesCommonCss.justifyContentBetween,
                                      classesCommonCss.cursorPointer
                                    )}
                                    display="flex"
                                    onClick={() => {
                                      onMultiSelect(
                                        "equipment",
                                        formObj.equipment,
                                        obj,
                                        obj.machineryUsageType
                                      );
                                    }}
                                  >
                                    <Box>{obj.machineryUsageType}</Box>
                                    <Box
                                      display={
                                        selectVal > -1 ? "block" : "none"
                                      }
                                      component="img"
                                      width="16px"
                                      mr={1}
                                      src="/assets/svg/check.svg"
                                    />
                                  </Box>
                                );
                              }):""} */}
                              <Box component="span">
                                <List className="scroll-bar  list-multi-dropdown"
                                  width={230}
                                  height={100}
                                  rowCount={equipmentDetails.length}
                                  rowHeight={20}
                                  rowRenderer={(props) => {
                                    const {
                                      key, index, isScrolling, isVisible, style,
                                    } = props
                                    let selectVal = formObj.equipment.indexOf(equipmentDetails[index].machineryUsageType);
                                    // //console.log(selectVal, equipmentDetails[index].machineryUsageType, 
                                    // formObj.equipment,'equipment7');
                                    return (
                                      <div key={key} style={style} onClick={() => {
                                        onMultiSelect(
                                          "equipment",
                                          formObj.equipment,
                                          equipmentDetails[index].machineryUsageType,
                                          equipmentDetails[index].machineryUsageType
                                        );
                                      }} className={clsx(
                                        selectVal > -1
                                          ? classes.selectDropdownActive
                                          : classes.selectDropdownInactive,
                                        classesCommonCss.justifyContentBetween,
                                        classesCommonCss.cursorPointer
                                      )} title={equipmentDetails[index].machineryUsageType}>
                                        {
                                          equipmentDetails[index].machineryUsageType ? (<EllipsisText
                                            text={equipmentDetails[index].machineryUsageType}
                                            length={"30"} />) : ''
                                        }

                                      </div>
                                    );
                                  }}
                                  length={"5"}
                                > </List> </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box width={0.5}>
                      {equipmentDetails.length ? equipmentDetails.map((obj) => {
                        let selectVal = formObj.equipment.indexOf(obj.machineryUsageType);
                        return (
                          <React.Fragment key={obj.machineryUsageType}>
                            {selectVal > -1 ? (
                              <Box
                                component="span"
                                className={classes.seletedItem}
                              >
                                <Box component="span">{obj.machineryUsageType}</Box>
                                <Box
                                  className={classesCommonCss.cursorPointer}
                                  component="img"
                                  width="8px"
                                  ml={0.5}
                                  onClick={() => {
                                    onMultiSelect(
                                      "equipment",
                                      formObj.equipment,
                                      obj,
                                      obj.machineryUsageType
                                    );
                                  }}
                                  src="/assets/svg/close.svg"
                                />
                              </Box>
                            ) : ""}
                          </React.Fragment>
                        )
                      }) : ""}
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Button type="button" onClick={() => {
                    history.push("/dashboard/admin");
                  }} className={classes.btnStyle2}>
                    cancel
                  </Button>
                  {customerDetails.length > 0  && formObj.role !== null && formObj.userType !== null ? (
                    <Button type="submit" className={classes.btnStyle2}>
                      Save
                    </Button>
                  ) : (
                    <Button type="submit" className={classes.btnStyle2} variant="contained" disabled>
                      Save
                    </Button>
                  )}
                </Grid>
              </Grid>
            </form>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}